import { CometChatCalls } from '@cometchat/calls-sdk-javascript';
import { CometChatUIKit } from '@cometchat/chat-uikit-react';
import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { COMETCHAT_CONSTANTS } from './AppConstants';
import HistoryScreen from './History';
import Home from './Home';
import LoginWithFirebase from './LoginWithFirebase';
import { auth, signOutFirebase } from './firebase';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isFirebaseReady, setIsFirebaseReady] = useState(false);

  useEffect(() => {
    const initSDK = async () => {
      try {
        const authKey =
          COMETCHAT_CONSTANTS.AUTH_KEY || localStorage.getItem('authKey') || '';

        const { error } = await CometChatCalls.init({
          appId: COMETCHAT_CONSTANTS.APP_ID,
          region: COMETCHAT_CONSTANTS.REGION,
          authKey: authKey,
          adminHost: `https://${COMETCHAT_CONSTANTS.APP_ID}.api-${COMETCHAT_CONSTANTS.REGION}.${COMETCHAT_CONSTANTS.IS_STAGING ? 'cometchat-staging.com' : 'cometchat.io'}/v3.0`,
          clientHost: `https://${COMETCHAT_CONSTANTS.APP_ID}.apiclient-${COMETCHAT_CONSTANTS.REGION}.${COMETCHAT_CONSTANTS.IS_STAGING ? 'cometchat-staging.com' : 'cometchat.io'}/v3.0`,
          host: `https://${COMETCHAT_CONSTANTS.APP_ID}.call-${COMETCHAT_CONSTANTS.REGION}.${COMETCHAT_CONSTANTS.IS_STAGING ? 'cometchat-staging.com' : 'cometchat.io'}/v3.0`,
        });

        if (error) {
          console.error('CometChat SDK initialization failed:', error);
          return;
        }

        setIsInitialized(true);
        console.log('Calls SDK initialized successfully');
      } catch (error) {
        console.error('CometChat SDK initialization failed:', error);
      }
    };

    initSDK();
  }, []);

  // Listen for Firebase authentication state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) {
        const cometChatUser = CometChatCalls.getLoggedInUser();
        if (cometChatUser) {
          setIsLoggedIn(true);
        }
      } else {
        setIsLoggedIn(false);
      }
      setIsFirebaseReady(true);
    });

    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = async () => {
    try {
      await CometChatCalls.logout();
      await CometChatUIKit.logout();
      await signOutFirebase();
      setIsLoggedIn(false);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  // Show loading while SDK is initializing
  if (!isInitialized || !isFirebaseReady) {
    return (
      <div className="container-app" data-theme={'dark'}>
        <div className="card loading-container">
          <div className="loading-spinner" />
          <h2 className="loading-title">Initializing CometChat</h2>
          <p className="loading-subtitle">
            Setting up your communication experience...
          </p>
        </div>
      </div>
    );
  }

  // Show Firebase login if not logged in
  if (!isLoggedIn) {
    return (
      <div data-theme={'dark'}>
        <LoginWithFirebase onLoginSuccess={handleLoginSuccess} />
      </div>
    );
  }

  // Main App UI when logged in
  return (
    <div data-theme={'dark'} style={{ height: '100%', width: '100%' }}>
      <Routes>
        <Route
          path="/history"
          element={<HistoryScreen onLogout={handleLogout} />}
        />
        <Route path="*" element={<Home onLogout={handleLogout} />} />
      </Routes>
    </div>
  );
}

export default App;
